import { render, staticRenderFns } from "./DetailTicketDialog.vue?vue&type=template&id=35778628&scoped=true"
import script from "./DetailTicketDialog.vue?vue&type=script&lang=js"
export * from "./DetailTicketDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35778628",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35778628')) {
      api.createRecord('35778628', component.options)
    } else {
      api.reload('35778628', component.options)
    }
    module.hot.accept("./DetailTicketDialog.vue?vue&type=template&id=35778628&scoped=true", function () {
      api.rerender('35778628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/templateApp/dialog/DetailTicketDialog.vue"
export default component.exports